import { FilterOperator } from "../filterModel";
import type { ConditionRow } from "./conditionChain";
import { isConditionRowComplete } from "./conditionChain";
import { isValuelessOperator, joinLabel as defaultJoinLabel, operatorLabel as defaultOperatorLabel } from "./operators";

export interface ConditionSummaryOptions {
  /** Defaults to the term as typed; only a date term needs reformatting. */
  formatTerm?: (term: string, options?: { shortYear?: boolean }) => string;
  /** Names a valueless row; defaults to the locale's operator name. */
  operatorLabel?: (operator: FilterOperator) => string;
  joinLabel?: (join: ConditionRow["join"]) => string;
}

/** `a OR Gro AND Alb`: the complete rows' values with their joins; "" when no row is complete. */
export function summarizeConditions(
  rows: readonly ConditionRow[],
  {
    formatTerm = (term) => term,
    operatorLabel = defaultOperatorLabel,
    joinLabel = defaultJoinLabel,
  }: ConditionSummaryOptions = {},
): string {
  const complete = rows.filter((row) => isConditionRowComplete(row));
  const text = (row: ConditionRow) => {
    if (isValuelessOperator(row.operator)) return operatorLabel(row.operator);
    if (row.operator === FilterOperator.IN_RANGE) {
      return `${formatTerm(row.term, { shortYear: true })} – ${formatTerm(row.termTo, { shortYear: true })}`;
    }
    return formatTerm(row.term);
  };
  return complete.map((row, index) => (index === 0 ? text(row) : `${joinLabel(row.join)} ${text(row)}`)).join(" ");
}
